import axios from 'axios';
import { getConfig } from '../config';

export const referralAgentPublicApi = (action, payload = {}) =>
	referralAgentFetch({
		action,
		...payload,
	});

export const referralAgentApi = (action, payload, token, setToken, navigate) =>
	referralAgentFetch(
		{
			action,
			...(payload || {}),
		},
		token,
		setToken,
		navigate,
	);

export const uploadReferralAgentImage = async ({
	formData,
	token,
	setToken,
	navigate,
	signal,
	onUploadProgress,
}) => {
	formData.append('action', 'upload_images');
	const response = await axios.post(getConfig().REACT_APP_IMG_UPLOAD_LINK, formData, {
		signal,
		headers: {
			'sdk-authorization': `${token?.session_key}`,
		},
		onUploadProgress,
	});

	if (response.data?.type === 'error' && response.data?.message === 'Session expired') {
		setToken({});
		localStorage.removeItem('user-auth');
		navigate('/login');
	}

	return response;
};

const referralAgentFetch = async (payload, token, setToken, navigate) => {
	let result;
	try {
		result = await fetch(getConfig().REACT_APP_WEB_LINK, {
			method: 'post',
			headers: {
				'Content-Type': 'application/json',
				Accept: 'application/json',
				...(token?.session_key
					? {
							'sdk-authorization': `${token.session_key}`,
					  }
					: {}),
			},
			body: JSON.stringify(payload),
		});
	} catch (err) {
		window.dispatchEvent(
			new CustomEvent('global-alert', {
				detail: {
					message: 'Network error. Please check your connection and try again.',
					type: 'Error',
				},
			}),
		);
		return { type: 'error', message: 'Network error' };
	}

	if (!result.ok) {
		let message = `Server error (${result.status}). Please try again later.`;
		try {
			const maybeJson = await result.clone().json();
			if (maybeJson?.message) message = maybeJson.message;
		} catch (_) {
			try {
				const text = await result.clone().text();
				if (text) message = text;
			} catch (_) {}
		}
		window.dispatchEvent(
			new CustomEvent('global-alert', {
				detail: {
					message,
					type: 'Error',
				},
			}),
		);
		return { type: 'error', message };
	}

	const response = await result.json();
	if (response.type === 'error' && response.message === 'Session expired') {
		if (setToken) setToken({});
		localStorage.removeItem('user-auth');
		if (navigate) navigate('/login');
	}
	return response;
};

export const isSuccessResponse = (response) =>
	response?.type === 'success' || response?.type === 'Success';
